import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import type CaffeinateCampaignModel from './caffeinate-campaign.ts';
import type CaffeinateMailingModel from './caffeinate-mailing.ts';
import { Type } from '@warp-drive/core-types/symbols';

export default class CaffeinateCampaignSubscriptionModel extends Model {
  @attr declare token: string;
  @attr declare endedAt: string;
  @attr declare endedReason: string;
  @attr declare resubscribedAt: string;
  @attr declare unsubscribedAt: string;
  @attr declare unsubscribeReason: string;
  @attr declare subscriberType: string;
  @attr declare subscriberId: string;
  @attr declare userType: string;
  @attr declare userId: string;
  @attr declare createdAt: string;
  @attr declare updatedAt: string;

  @belongsTo('caffeinate-campaign', { async: false, inverse: 'caffeinateCampaignSubscriptions' })
  declare caffeinateCampaign: CaffeinateCampaignModel;

  @hasMany('caffeinate-mailing', { async: false, inverse: 'caffeinateCampaignSubscription' })
  declare caffeinateMailings: CaffeinateMailingModel[];

  [Type] = 'caffeinate-campaign-subscription' as const;
}
